<template>
  <input
    v-model="amount"
    type="text"
    @blur="$emit('blur', $event)"
    @input="setValue($event)"
  />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { toAmount, fromAmount } from '@/helpers/amount-input-helpers';

type Props = {
  modelValue: number;
};

const props = defineProps<Props>();
const emit = defineEmits(['blur', 'update:modelValue']);

const amount = ref<string>('');

watch(
  () => props.modelValue,
  (newValue) => {
    amount.value = fromAmount(newValue);
  },
  { immediate: true }
);

function setValue(event: Event) {
  const target = event.target as HTMLInputElement;
  const newAmount = toAmount(target.value);

  // Format the input value to strip out any unwanted characters
  amount.value = fromAmount(newAmount);

  // If amount didn't change don't update
  if (newAmount === props.modelValue) return;

  emit('update:modelValue', newAmount);
}
</script>
